<template>
    <div>
        <loading v-if="loading"></loading>
        <vue-apex-charts v-if="!loading" type="bar" height="400" :options="chartOptions" :series="series"></vue-apex-charts>
    </div>
</template>
<script>
    // import initFilterModel from '@/shared/filter';
    // import {formatDate, parseDate} from '@/shared/utils';
    import VueApexCharts from 'vue-apexcharts'
    import CurrencyFilter from '@/shared/filters/currency';
    import {findBy} from '@/shared/utils';
    import Loading from '@/views/Loading';


    // export const
    export default {
        name: "RegionsBarChart",
        props: {
            data: Object,
            title: String,
            organizationType: String,
        },
        components: {
            VueApexCharts,
            Loading
        },
        data() {
            return {
                loading: false,
                series: [
                    {
                        name: 'Хизмат хакки',
                        type: 'column',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    },
                    {
                        name: 'Туланган',
                        type: 'column',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    },
                    {
                        name: 'Туланмаган',
                        type: 'column',
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    }
                ],
                chartOptions: {
                    title: {
                        text: this.$props.title,
                        align: 'left',
                        offsetX: 110
                    },
                    tooltip: {
                        y: {
                            formatter: function(val) {
                                return CurrencyFilter(val, '', 2, { thousandsSeparator: ' ' });
                            },
                            title: {
                                formatter: function (seriesName) {
                                    return seriesName + ''
                                }
                            }
                        }
                        // custom: function ({series, /*seriesIndex, dataPointIndex, w*/}) {
                        //     return "<div>" + series + "</div>";
                        // }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            endingShape: 'flat',
                            columnWidth: '50px',
                            barHeight: '50px',
                            distributed: false,
                            colors: {
                                ranges: [{
                                    from: 0,
                                    to: 0,
                                    color: undefined
                                }],
                                backgroundBarColors: [],
                                backgroundBarOpacity: 1,
                            },
                            dataLabels: {
                                position: 'top',
                                maxItems: 100,
                                hideOverflowingLabels: true
                            }
                        }
                    },
                    dataLabels: {
                        enabled: false,
                        offsetX: -6,
                        style: {
                            fontSize: '12px',
                            colors: ['#fff']
                        }
                    },
                    stroke: {
                        show: true,
                        width: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
                        colors: ['#fff']
                    },

                    xaxis: {
                        categories: [],
                    },
                }
            }
        },
        methods: {
            initList(contractAmountTotal, province, regionIds) {
                // console.log(contractAmountTotal.ALL);
                if (this.$props.organizationType != null && province != null) {
                    this.setDataChart(contractAmountTotal[this.$props.organizationType], regionIds);
                } else {//by default
                    this.setDataChart(contractAmountTotal.ALL, regionIds);
                }
            },
            setDataChart(data, regionIds){
                this.loading = true;
                var contractAmounts = [];
                var paids = [];
                var unpaids = [];

                for (var i = 0; i < regionIds.length; i++) {
                    var item = findBy(data.regions, "id", regionIds[i]);
                    if (item != null) {
                        contractAmounts.push(item.contractAmount);
                        paids.push(item.paid);
                        unpaids.push(item.unpaid);
                    } else {
                        contractAmounts.push(0.0);
                        paids.push(0.0);
                        unpaids.push(0.0);
                    }
                }

                this.series = [
                    {
                        name: 'Хизмат хакки',
                        type: 'column',
                        data: contractAmounts
                    },
                    {
                        name: 'Туланган',
                        type: 'column',
                        data: paids
                    },
                    {
                        name: 'Туланмаган',
                        type: 'column',
                        data: unpaids
                    }
                ];
                this.loading = false;
            }
        },
        created() {
            this.$eventBus.$on('refreshRegionsBarChart', (data) => {
                this.chartOptions = {
                    title: {
                        text: data.barTitle,
                        align: 'left',
                        offsetX: 110
                    }
                };
                if (data.province != null) {
                    var regions = [];
                    var regionIds = [];
                    for (var i = 0; i < data.province.regions.length; i++) {
                        regions.push(data.province.regions[i].name);
                        regionIds.push(data.province.regions[i].id);
                    }
                    this.chartOptions = {
                        title: {
                            text: data.barTitle,
                            align: 'left',
                            offsetX: 110
                        },
                        xaxis:{
                            categories: regions
                        }
                    };
                    this.initList(data.contractAmountTotal, data.province, regionIds);
                }


            });
        },
        computed: {

        },
    }
</script>
<style>

</style>

